import { useEffect, useState } from 'react';

function readVisible(): boolean {
  return typeof document === 'undefined' || document.visibilityState !== 'hidden';
}

export function usePageVisible(): boolean {
  const [visible, setVisible] = useState(readVisible);

  useEffect(() => {
    const onChange = () => setVisible(readVisible());
    document.addEventListener('visibilitychange', onChange);
    return () => document.removeEventListener('visibilitychange', onChange);
  }, []);

  return visible;
}
